export function hasOnlyNumbers(value: string): boolean {
  return /^\d+$/.test(value);
}
